/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Patient_Knotty_Horse_TapInputs */

const es_patient_knotty_horse_tap = /** @type {(inputs: Patient_Knotty_Horse_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un momento..`)
};

const gl_patient_knotty_horse_tap = /** @type {(inputs: Patient_Knotty_Horse_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un momento..`)
};

const en_patient_knotty_horse_tap = /** @type {(inputs: Patient_Knotty_Horse_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One moment..`)
};

/**
* | output |
* | --- |
* | "One moment.." |
*
* @param {Patient_Knotty_Horse_TapInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const patient_knotty_horse_tap = /** @type {((inputs?: Patient_Knotty_Horse_TapInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Patient_Knotty_Horse_TapInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_patient_knotty_horse_tap(inputs)
	if (locale === "en") return en_patient_knotty_horse_tap(inputs)
	return es_patient_knotty_horse_tap(inputs)
});